export const AGES_ALL = 'AGES_ALL';
export const AGES_18 = 'AGES_18';
export const AGES_21 = 'AGES_21';

export const AGE_RESTRICTION_DISPLAY = {
  [AGES_ALL]: 'All Ages',
  [AGES_21]: '21+',
  [AGES_18]: '18+',
};
